module.exports = __webpack_public_path__ + "img/aic.e08859ff.png";